import { render, staticRenderFns } from "./Package3Card.vue?vue&type=template&id=0c6227d4&scoped=true"
import script from "./Package3Card.vue?vue&type=script&lang=ts"
export * from "./Package3Card.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6227d4",
  null
  
)

export default component.exports